export let _loadingCount = 0;
let _loadingLine;
let _loadingOverlay;

export const loading = () => {
    _loadingCount++;
    if (!_loadingLine) {
        _loadingOverlay = $('<div id="loading-overlay" class="loading-overlay"></div>');
        _loadingLine = $(`
        <div id="loading-line" class="loading-line">
          <div class="loading-line-bar"></div>
        </div>
      `);
        $('body').append(_loadingOverlay).append(_loadingLine);
    }
    _loadingOverlay.show();
    _loadingLine.show();
};

export const unloading = force => {
    if (_loadingCount > 0) {
        _loadingCount--;
    }

    if (force) {
        _loadingCount = 0;
    }

    if (_loadingCount === 0 && _loadingLine) {
        _loadingLine.hide();
        _loadingOverlay.hide();
    }
};



// WEBPACK FOOTER //
// ./src/scripts/shared/loading.js